const rowIdentity = (row: any, index: number): string => {
  if (row?.rowType === "header") {
    return `header:${row.id ?? ""}:${row.position ?? ""}:${row.title ?? ""}:${index}`;
  }

  if (row?.id !== undefined && row?.id !== null) {
    return `item:${row.id}`;
  }

  return `item-index:${index}`;
};

export const rebuildPagesFromSource = (
  sourceRows: any[],
  candidatePages: any[][],
  fallbackCapacity: number
): any[][] => {
  const identities = sourceRows.map(rowIdentity);
  if (new Set(identities).size !== identities.length) {
    throw new Error("PDF source rows contain duplicate stable identities");
  }

  const capacities = candidatePages
    .filter(Array.isArray)
    .map((page) => page.length)
    .filter((capacity) => capacity > 0);

  const pages: any[][] = [];
  let cursor = 0;

  capacities.forEach((capacity) => {
    if (cursor >= sourceRows.length) return;
    pages.push(sourceRows.slice(cursor, cursor + capacity));
    cursor += capacity;
  });

  const safeFallback = Math.max(1, fallbackCapacity);
  while (cursor < sourceRows.length) {
    pages.push(sourceRows.slice(cursor, cursor + safeFallback));
    cursor += safeFallback;
  }

  return pages;
};

export const getPdfItemIds = (pages: any[][]): Array<string | number> =>
  pages.flatMap((page) =>
    page
      .filter((row) => row?.rowType !== "header")
      .map((row) => row.id)
  );
